import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { Button, Callout, Modal, Paragraph, Popover, Select, Spinner } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

function UserSelector(props: {
	excluded?: string[];
	selected?: string;
	setSelected: (id?: string) => void;
}) {
	const { data, loading } = graphql.useOrganizationEmployeesQuery({
		variables: {
			status: graphql.UserStatus.Active,
			first: 10000,
		},
	});

	const options = data?.users.edges
		.filter(({ node }) => !props.excluded?.includes(node.id))
		.map((edge) => ({
			title: `${edge.node.firstName} ${edge.node.lastName}`,
			value: edge.node.id,
		}));

	return loading ? (
		<Flex height={40} alignItems="center">
			<Spinner />
		</Flex>
	) : (
		<Select
			selectedValue={options?.find((option) => option.value === props.selected)?.value}
			onChange={(selection) => props.setSelected(selection)}
			options={options}
		/>
	);
}

export default function ChangeConversationPartner(props: {
	id: string;
	employeeID: string;
	userID: string;
	enabled?: boolean;
	onCompleted?: () => void;
	onDismiss?: () => void;
}) {
	const { t } = useTranslation();
	const [userID, setUserID] = useState<string | undefined>(props.userID);

	const [commit] = graphql.useChangeConversationPartnerMutation();

	return (
		<Popover visible center>
			<Modal width={400} height="auto">
				<Modal.Header
					title={t('evaluation.submission.changeConversationPartner.title')}
					onClose={() => props.onDismiss?.()}
				/>
				<Modal.Contents>
					{props.enabled ? (
						<>
							<Paragraph mb={3}>
								{t('evaluation.submission.changeConversationPartner.message')}
							</Paragraph>
							<Flex>
								<Box mr={2}>
									<UserSelector
										excluded={[props.employeeID]}
										selected={userID}
										setSelected={setUserID}
									/>
								</Box>
								<Button
									small
									type="primary"
									title={t('evaluation.submission.changeConversationPartner.save')}
									onClick={async () => {
										if (!userID) {
											return;
										}

										await commit({
											variables: {
												input: {
													id: props.id,
													userID,
												},
											},
										});

										props.onCompleted?.();
										props.onDismiss?.();
									}}
									disabled={userID === props.userID || userID === undefined}
								/>
							</Flex>
						</>
					) : (
						<Callout color="red">
							{t('evaluation.submission.changeConversationPartner.impossible')}
						</Callout>
					)}
				</Modal.Contents>
			</Modal>
		</Popover>
	);
}
